export default {
  'tips.test': `Sorry, you don't have access to this page`
}
